interface DeliveryBusyWarningProps {
  isOpen: boolean;
  onClose: () => void;
  onPlaceOrder: () => void;
}

export default function DeliveryBusyWarning({ isOpen, onClose, onPlaceOrder }: DeliveryBusyWarningProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[85] flex items-end sm:items-center justify-center p-3 bg-black/70 backdrop-blur-sm">
      <div className="bg-white rounded-2xl w-full max-w-sm overflow-hidden animate-slide-in">
        {/* Header — compact */}
        <div className="relative bg-gradient-to-br from-amber-500 to-orange-500 px-5 pt-5 pb-4 text-center">
          <div className="w-14 h-14 rounded-xl bg-white/20 border border-white/30 flex items-center justify-center mx-auto mb-3 relative">
            <i className="ri-e-bike-2-line text-white text-2xl"></i>
            <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-red-500 border-2 border-white flex items-center justify-center">
              <i className="ri-loader-4-line text-white text-[10px] animate-spin"></i>
            </span>
          </div>
          <h2 className="text-white font-bold text-base mb-0.5">Delivery Partners Busy!</h2>
          <p className="text-white/80 text-xs">All delivery partners are currently on orders</p>
        </div>

        {/* Body — compact */}
        <div className="px-5 py-4 space-y-3">
          {/* Info card */}
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 flex items-start gap-2.5">
            <div className="w-7 h-7 rounded-lg bg-amber-500 flex items-center justify-center shrink-0">
              <i className="ri-time-line text-white text-sm"></i>
            </div>
            <div>
              <p className="text-gray-900 font-bold text-xs">Order Delay Possible</p>
              <p className="text-gray-500 text-xs leading-relaxed mt-0.5">
                Sabhi delivery partners active orders par hain. Order place hoga lekin delivery mein thodi der ho sakti hai.
              </p>
            </div>
          </div>

          {/* What happens — compact */}
          <div className="space-y-1.5">
            {[
              { icon: 'ri-check-line', color: 'bg-green-100 text-green-600', text: 'Order confirm hoga aur queue mein lag jayega' },
              { icon: 'ri-check-line', color: 'bg-green-100 text-green-600', text: 'Partner free hote hi delivery start hogi' },
              { icon: 'ri-time-line', color: 'bg-amber-100 text-amber-600', text: 'Normal se thoda zyada time lag sakta hai' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className={`w-5 h-5 rounded-full ${item.color} flex items-center justify-center shrink-0`}>
                  <i className={`${item.icon} text-[10px]`}></i>
                </div>
                <p className="text-gray-600 text-xs">{item.text}</p>
              </div>
            ))}
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col gap-2 pt-1">
            <button
              onClick={onPlaceOrder}
              className="w-full py-3 rounded-xl bg-gray-900 text-white font-bold text-sm flex items-center justify-center gap-2 hover:bg-gray-800 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-check-double-line"></i>
              No Problem, Place My Order
            </button>
            <button
              onClick={onClose}
              className="w-full py-2.5 rounded-xl border border-gray-200 text-gray-600 font-semibold text-sm flex items-center justify-center gap-2 hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-time-line"></i>
              I'll Place Order After Sometime
            </button>
          </div>

          <p className="text-center text-gray-400 text-[10px]">
            Cash on Delivery · Free Delivery
          </p>
        </div>
      </div>
    </div>
  );
}
